import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';
import { localizeRoutes } from '../utils/routeUtils';

import ProfilePage from '../components/pages/account/myprofile/ProfilePage';
import MessagePage from '../components/pages/account/mymessages/MessagePage';
import InterestsPage from '../components/pages/account/myinterests/InterestsPage';
import MyMessagesPage from '../components/pages/account/mymessages/MyMessagesPage';
import GodchildrenPage from '../components/pages/account/godchildren/GodchildrenPage';
import AccountPurchasePage from '../components/pages/account/cashback/AccountPurchasePage';

export const accountLocalizableRoutes = [
    {
        path: PATH.ACCOUNT_MESSAGE_PATH,
        component: MyMessagesPage,
        exact: true
    },
    {
        path: `${PATH.ACCOUNT_MESSAGE_PATH}/:id`,
        component: MessagePage
    },
    {
        path: PATH.ACCOUNT_JACKPOT_PATH,
        component: AccountPurchasePage,
        exact: true
    },
    {
        path: PATH.ACCOUNT_CENTER_PATH,
        component: InterestsPage,
        exact: true
    },
    {
        path: PATH.ACCOUNT_PROFILE_PATH,
        component: ProfilePage,
        exact: true
    },
    {
        path: PATH.ACCOUNT_GODCHILDREN_PATH,
        component: GodchildrenPage,
        exact: true
    }
    /* put the default child page HERE !
    {
        component:
    }
    */
];

export const accountRoutes = [
    ...accountLocalizableRoutes,
    ...localizeRoutes(LOCALES, accountLocalizableRoutes)
];



// WEBPACK FOOTER //
// ./src/routes/account.js